const siteSegmentsReducer = (siteSegmentsState = {}, action: AnyFixMe) => {
  switch (action.type) {
    default:
      return siteSegmentsState;
  }
};

export default siteSegmentsReducer;
